import React from 'react';

const LearnMenu = () => {
  return (
    <div>
      <p>
        From the dashboard you can access your report and other available
        resources through the menu to the left and you can see below what is
        included.
      </p>
    </div>
  );
};

export default LearnMenu;
